import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { getImagePath } from '../../utils/imagePath';

const TableTennis = () => {
  const [activeImage, setActiveImage] = useState(0);

  const sectionData = {
    name: 'Table Tennis',
    category: 'Racket Sports',
    description: 'Fast-paced table tennis for all skill levels.',
    longDescription: 'Experience the thrill of table tennis in our dedicated facility. With professional-grade tables, automated training robots, and experienced coaches, we provide the perfect environment to develop your skills. From casual play to competitive tournaments, our club welcomes players of all ages and abilities.',
    images: [
      getImagePath('images/bars/table_tennis.jpg'),
      getImagePath('images/bars/table_tennis.jpg'),
      getImagePath('images/bars/table_tennis.jpg')
    ],
    icon: 'fa-table-tennis',
    members: '40+ active members',
    coach: 'National Team Coach James Okonkwo',
    schedule: 'Tue, Thu: 5pm | Sat: 10am',
    level: 'All Levels',
    features: [
      'Professional Tables',
      'Training Robots',
      'Group Coaching',
      'Private Lessons',
      'Weekly Tournaments',
      'Junior Program',
      'Equipment Sales',
      'Bat Customization'
    ],
    facilities: ['Air-conditioned Hall', 'Training Area', 'Equipment Shop', 'Waiting Lounge'],
    contact: {
      phone: '+234 905 584 6379',
      email: 'tabletennis@nlngraclub.com',
      extension: '214'
    },
    programs: ['Beginner Classes', 'Intermediate Coaching', 'Advanced Training', 'Junior Squad'],
    events: ['Weekly Tournament', 'Monthly Championship', 'Club League']
  };

  return (
    <div className="section-detail-page">
      {/* Hero Section */}
      <section className="section-detail-hero">
        <div className="hero-background">
          <img src={sectionData.images[0]} alt={sectionData.name} />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Link to="/sections" className="back-link">
              <i className="fas fa-arrow-left"></i> Back to Sections
            </Link>
            <span className="section-category">{sectionData.category}</span>
            <h1 className="section-title">{sectionData.name}</h1>
            <p className="section-subtitle">{sectionData.description}</p>
          </motion.div>
        </div>
      </section>

      {/* Section Content */}
      <section className="section-content-section">
        <div className="container">
          <div className="section-grid">
            {/* Left Column - Images */}
            <div className="section-gallery">
              <div className="main-image">
                <img 
                  src={sectionData.images[activeImage]} 
                  alt={sectionData.name} 
                />
              </div>
              <div className="image-thumbnails">
                {sectionData.images.map((img, index) => (
                  <button 
                    key={index} 
                    className={`thumbnail-btn ${activeImage === index ? 'active' : ''}`}
                    onClick={() => setActiveImage(index)}
                  >
                    <img src={img} alt={`${sectionData.name} ${index + 1}`} />
                  </button>
                ))}
              </div>
            </div>

            {/* Right Column - Details */}
            <div className="section-details">
              <div className="detail-section">
                <h2>About {sectionData.name}</h2>
                <p className="section-description">{sectionData.longDescription}</p>
              </div>

              <div className="coach-info">
                <div className="info-card">
                  <i className="fas fa-user-tie"></i>
                  <div>
                    <h4>Head Coach</h4>
                    <p>{sectionData.coach}</p>
                  </div>
                </div>
                <div className="info-card">
                  <i className="fas fa-users"></i>
                  <div>
                    <h4>Members</h4>
                    <p>{sectionData.members}</p>
                  </div>
                </div>
                <div className="info-card">
                  <i className="fas fa-clock"></i>
                  <div>
                    <h4>Schedule</h4>
                    <p>{sectionData.schedule}</p>
                  </div>
                </div>
              </div>

              <div className="detail-section">
                <h3>Key Features</h3>
                <ul className="features-list">
                  {sectionData.features.map((feature, index) => (
                    <li key={index}>
                      <i className="fas fa-check-circle"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="additional-info">
                <div className="info-row">
                  <span className="info-label">Programs:</span>
                  <span className="info-value">{sectionData.programs.join(' • ')}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">Events:</span>
                  <span className="info-value">{sectionData.events.join(' • ')}</span>
                </div>
              </div>

              <div className="action-buttons">
                <Link to="/login" className="btn btn-primary btn-large">
                  <i className="fas fa-handshake"></i> Join This Section
                </Link>
                <Link to="/contact" className="btn btn-outline btn-large">
                  <i className="fas fa-calendar"></i> Try a Session
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TableTennis;